'use strict';
/* Original: https://github.com/sinmsinm/ng-window-manager */
/* eslint-disable space-before-function-paren,comma-spacing,no-spaced-func,key-spacing,space-infix-ops,space-in-parens */

/**
 * @ngdoc directive
 * @name ngWindowManager.directive:wmwindow
 * @description
 * # wmWindow
 */

let classVarWindowPos:any = {};

import * as angular from 'angular';

export default angular.module('wmwindow', [])
  .directive('wmwindow', function($timeout) {
    return {
      template: require('./wmwindow.directive.html').default,
      restrict: 'E',
      replace: true,
      transclude: true,
      require: '^^?containerwm',
      scope: {
        windowTitle: '=?',
        // close: '=',
        onClose: '&',
        onFocus: '&',
        open: '=',
        // selectwindow: '=',
        // maximize: '=',
        // restore: '=',
        options: '@',
        maximizable: '@',
        closeable: '@',

        ngModel: '=',
        container: '=',
        application: '=',
        left: '@',
        top: '@',
        right: '@',
        bottom: '@',

        zIndex: '=',
        focused: '=',

        controller: '=',
      },
      link: {
        pre: function(scope:any, element, attrs) {
          console.log("wmwindow:pre");
          if('windowTitle' in attrs) {
            scope.windowTitle = (scope.windowTitle && (scope.windowTitle.title || scope.windowTitle)) || scope.application;
          }
          // scope.ngModel.title = scope.title;
          scope.$on('title', function(event, title){
            if('windowTitle' in attrs) {
              scope.windowTitle = (title && title.text) || title;
            }
            // scope.ngModel.title = scope.title;
          });
          scope.$on('application:close', function(event){
            scope.close();
          });
        },
        post: function(scope:any, element:any, attrs, containerwmCtrl:any) {
          scope.contextmenu = {};
          scope.isopen = false;
          scope.showApplicationMenu = (event, self) => {
            scope.$broadcast('showApplicationMenu', event, self);
          };
          let windowPos = classVarWindowPos;
          if(containerwmCtrl){
            containerwmCtrl.windowPos = containerwmCtrl.windowPos || {};
            windowPos = containerwmCtrl.windowPos;
          }
          windowPos.left = windowPos.left || 270;
          windowPos.top = windowPos.top || 70;

          console.log("wmwindow:post");
          // element = $(element[0].children);
          scope.viewCtrl = {};

          if(!scope.left && !scope.right){
            scope.left = windowPos.left;
            windowPos.left += 30;
            if(windowPos.left > window.innerWidth - 200){
              windowPos.left = 30;
            }

            scope.top = windowPos.top;
            windowPos.top += 30;
            if(windowPos.top > window.innerHeight - 200){
              windowPos.top = 30;
            }
          }

          scope.width = scope.width || 600;
          scope.height = scope.height || 400;

          // var parentWindow = element[0].parentElement;

          /*
          var titleBarElement = element[0].children[0].children[0];
          var contentButtonElement = element[0].children[0].children[1];
          var resizeButtonElement = element[0].children[0].children[2];

          var buttonBar = titleBarElement.children[1];
          */

          scope.fMaximized = false;
          // var maximizeButton = buttonBar.children[0];
          // var closeButton = buttonBar.children[2];

          // State variables
          let positionState:{x:number, y:number}|null = null;
          let sizeState:any = null;
          let maximizeState:any = null;

          let winHandler:any = {};
          winHandler.elem = element;

          // Parse the options
          let options = scope.options ? JSON.parse(scope.options) : {};

          // If it's defined a windowContainer zone we will use it to bind
          // all the listeners, that way we can fit windows under an element but move in other
          // var windowArea = options.windowContainer===undefined ? parentWindow : document.getElementById(options.windowContainer);
          // windowArea = document;
          let windowArea = window;
          // Set some tricky controls to handle the layering
          // parentWindow.topZ = parentWindow.topZ || options.initialZIndex || angular.element(parentWindow).css('z-index') || 100000;

          if(scope.controller){
            scope.controller.onbeforeunload = () => {
              if(scope.viewCtrl.onbeforeunload){
                return scope.viewCtrl.onbeforeunload();
              }
            };
            scope.controller.close = (fDelete) => {
              if(scope.viewCtrl.close){
                return scope.viewCtrl.close(fDelete);
              }
            };
            scope.controller.focus = () => {
              // element.focus();
              scope.$broadcast('focus', null);
            };
          }

          scope.maximize = (e) => {
            // scope.container.orderAndFocusLast();
            scope.container.desktop.windowModels.sort((a, b) => b.zIndex - a.zIndex);
            containerwmCtrl.changeWindowManager('tab');
            /*
            winHandler.maximize(() => {
              scope.$broadcast('resize', e);
            });
            */
          };
          scope.restore = (e) => {
            winHandler.restore(() => {
              scope.$broadcast('resize', e);
            });
          };

          scope.$on('close', (event, title) => {
            winHandler.close();
          });
          scope.$on('resize view', (event, width, height) => {
            console.log('resize view', event, width, height);
            if(scope.fMaximized){
              return;
            }
            let titleBarHeight = element.find('.wmTitleBar').height();
            winHandler.resize(width, height + titleBarHeight);
          });
          scope.$on('focus', (event) => {
            console.log("wmwindow:focus");
            winHandler.onSelectWindow();
          });
          // This function is executed when close button is pushed
          winHandler.close = () => {
            setTimeout(function(){
              element.addClass('closing');
              setTimeout(function(){
                element.removeClass('closing');
                element.remove();
              }, 300);
            }, 50);
            /*
            if(scope.viewCtrl.close){
              scope.viewCtrl.close();
            }*/
            if (scope.onClose){
              // scope.close(winHandler);
              scope.onClose();
            }
          };
          scope.close = () => {
            let msg;
            if(scope.viewCtrl.onbeforeunload){
              msg = scope.viewCtrl.onbeforeunload();
            }
            if(msg){
              window.swal({
                title: 'Are you sure?',
                text: msg,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                // closeOnConfirm: false,
              }).then(function(){
                // window.confirm();
                winHandler.close();
              });
            }else{
              winHandler.close();
            }
          };

          scope.isMaximizable = function(){
            return (scope.maximizable === undefined || scope.maximizable === true || scope.maximizable === 'true');
          };

          scope.isCloseable = function(){
            return (scope.closeable === undefined || scope.closeable === true || scope.closeable === 'true');
          };

          function movingClickHandler(e){
            console.log('movingClickHandler');
            e.preventDefault();
            e.stopPropagation();
          }

          // Executed when touches or clicks in the title bar
          scope.startMoving = (e) => {
            console.log('wmwindow:startMoving');
            scope.moving = true;

            let isTouch = (e.targetTouches && e.targetTouches.length === 1);
            let moveRef = isTouch ? e.targetTouches[0] : e;

            positionState = calculatePos({
              x: moveRef.pageX,
              y: moveRef.pageY,
            });

            element.addClass('moving');

            scope.movingIsTouch  = isTouch;
            windowArea.addEventListener(isTouch ? 'touchmove' : 'mousemove', dragWindow);
            windowArea.addEventListener(isTouch ? 'touchend' : 'mouseup', dragWindowEnds);

            winHandler.selectWindow(e);

            e.preventDefault();
          };

          const directionsX = [-1, 0, 1,-1, /*0,*/ 1,-1, 0, 1]; // eslint-disable-line comma-spacing
          const directionsY = [-1,-1,-1, 0, /*0,*/ 0, 1, 1, 1]; // eslint-disable-line comma-spacing

          // Executed when touches or clicks in the resize button
          scope.startResizing = (e, dx, dy) => {
            console.log('wmwindow startResizing');
            scope.resizing = true;

            const isTouch = (e.targetTouches && e.targetTouches.length === 1);
            const moveRef = isTouch ? e.targetTouches[0] : e;

            const edge = 5;
            const left = element[0].offsetLeft;
            const width = element[0].offsetWidth;
            const top = element[0].offsetTop;
            const height = element[0].offsetHeight;
            const pageX = moveRef.pageX;
            const pageY = moveRef.pageY;

            /*
            var d;
            for(d=0;d<8;d++){
              var x = directionsX[d], y = directionsY[d];
              var xok = false, yok = false;
              if(x===-1){
                if(Math.abs(left - pageX) < edge){
                  xok = true;
                }
              }else if(x===0){
                if(left + edge < pageX && pageX < left + width - edge){
                  xok = true;
                }
              }else if(x===1){
                if(Math.abs(left + width - pageX) < edge){
                  xok = true;
                }
              }
              if(y===-1){
                if(Math.abs(top - pageY) < edge){
                  yok = true;
                }
              }else if(y===0){
                if(Math.abs(top + edge < pageY && pageY < top + height - edge)){
                  yok = true;
                }
              }else if(y===1){
                if(Math.abs(top + height - pageY) < edge){
                  yok = true;
                }
              }
              if(xok && yok){
                break;
              }
            }
            if(d === 8){
              return;
            }
            */

            sizeState = {
              dx: dx,
              dy: dy,
              pageX: moveRef.pageX,
              pageY: moveRef.pageY,
              top: element.offset().top,
              left: element.offset().left,
              width: element.width(),
              height: element.height(),
              /*
              width: parseInt(element.prop('offsetWidth'), 10),
              height: parseInt(element.prop('offsetHeight'), 10),
              */
            };

            /*
            sizeState = calculateSize ({
              width:  moveRef.pageX,
              height: moveRef.pageY
            });
    */

            element.addClass('resizing');

            scope.resizingIsTouch = isTouch;
            windowArea.addEventListener(isTouch ? 'touchmove' : 'mousemove' , dragWindowCorner);
            windowArea.addEventListener(isTouch ? 'touchend' : 'mouseup', dragWindowCornerEnds);
            winHandler.selectWindow(e);

            e.preventDefault();
            window.addEventListener('click', movingClickHandler, true)

          };
          // scope.startResizing = startResizing;

          // Execute when user moves the mouse after title is clicked
          function dragWindow(e) {
            const moveRef = (e.targetTouches && e.targetTouches.length === 1) ? e.targetTouches[0] : e;

            if (positionState){
              winHandler.move(
                moveRef.pageX - positionState.x,
                moveRef.pageY - positionState.y);
            }

            e.preventDefault();
          }

          // Execute when user moves the pointer after resize button is clicked
          function dragWindowCorner(e){
            const moveRef = (e.targetTouches && e.targetTouches.length === 1) ? e.targetTouches[0] : e;

            if (sizeState){
              /*
              winHandler.resize (
                moveRef.pageX + sizeState.width,
                moveRef.pageY + sizeState.height
              );
              */
              const xdiff = moveRef.pageX - sizeState.pageX;
              const ydiff = moveRef.pageY - sizeState.pageY;
              let left = sizeState.left, top = sizeState.top, width = sizeState.width, height = sizeState.height;
              if(sizeState.dx === -1){
                left = sizeState.left + xdiff;
                width = sizeState.width - xdiff;
              }else if(sizeState.dx === 1){
                width = sizeState.width + xdiff;
              }
              if(sizeState.dy === -1){
                top = sizeState.top + ydiff;
                height = sizeState.height - ydiff;
              }else if(sizeState.dy === 1){
                height = sizeState.height + ydiff;
              }
              winHandler.move(left, top);
              winHandler.resize(width, height);

              /*
              winHandler.resize (
                sizeState.width + (moveRef.pageX - sizeState.pageX),
                sizeState.height + (moveRef.pageY - sizeState.pageY)
              );
              */
            }

            e.preventDefault();
          }

          // The user ends moving window when mouseup or touchends
          function dragWindowEndsItr(e){
            scope.moving = false;

            // const isTouch = (e.targetTouches && e.targetTouches.length === 1);
            const isTouch = scope.movingIsTouch;

            if (positionState) {
              element.removeClass('moving');
              positionState = null;
            }

            windowArea.removeEventListener(isTouch ? 'touchmove' : 'mousemove', dragWindow);
            windowArea.removeEventListener(isTouch ? 'touchend' : 'mouseup', dragWindowEnds);
            // titleBarElement.removeEventListener ('click', winHandler.selectWindow);

            e.preventDefault();
            scope.selectWindow(null);
          }
          const dragWindowEnds = (e) => {
            scope.$apply(() => {
              dragWindowEndsItr(e);
            });
          };

          // The user ends moving the resize button when mouseup or touchends
          function dragWindowCornerEnds(e){
            console.log('wmwindow dragWindowCornerEnds', e);

            scope.resizing = false;

            // const isTouch = (e.targetTouches && e.targetTouches.length === 1);

            if (sizeState){
              element.removeClass('resizing');
              sizeState = null;
            }

            const isTouch = scope.resizingIsTouch;

            windowArea.removeEventListener(isTouch ? 'touchmove' : 'mousemove',dragWindowCorner);
            windowArea.removeEventListener(isTouch ? 'touchend' : 'mouseup',dragWindowCornerEnds);

            scope.$broadcast('resize', e);
            e.preventDefault();

            $timeout(() => {
              window.removeEventListener('click', movingClickHandler, true);
              scope.selectWindow(null);
            }, 301);
          }

          // it just makes a postion calculation from the current positon reference passed
          function calculatePos(ref) {
            const winX = parseInt(element.prop('offsetLeft'), 10);
            const winY = parseInt(element.prop('offsetTop'), 10);

            return {
              x: ref.x - winX,
              y: ref.y - winY,
            };
          }

          // it just makes a size calculation from the current positon reference passed
          function calculateSize(ref){
            const winWidth = parseInt(element.prop('offsetWidth'), 10);
            const winHeight = parseInt(element.prop('offsetHeight'), 10);

            return {
              width: winWidth - ref.width,
              height: winHeight - ref.height,
            };
          }

          // set the element in the specified position
          winHandler.move = function(x, y) {
            x = Math.max(x, - element.width() + 10);
            y = Math.max(y, -12);

            x = Math.min(x, element.parent().width() - 10);
            y = Math.min(y, element.parent().height() - 10);

            // console.log('winHandler.move', x, y);
            if (x) { scope.left = x; }
            if(y) { scope.top = y; }
            if (x) {element.css('left',x +'px');}
            if(y) {element.css('top',y + 'px');}

          };

          // set the new size of the element
          winHandler.resize = function(width,height) {
            console.log('winHandler.resize', width, height);
            if (width) {scope.width = width;}
            if (height) {scope.height = height;}
            if (width) {element.css('width', width + 'px');}
            if (height) {element.css('height', height + 'px');}
          };

          winHandler.onSelectWindow = function(ev){
            console.log("onSelectWindow", ev);
            /*
            parentWindow.topZ = parentWindow.topZ +1;
            element.css ('z-index', parentWindow.topZ);
            */
            // if (scope.selectWindow) { scope.selectwindow(winHandler); }
            if (scope.onFocus){ scope.onFocus(); }
          };
          // Move the current window to the highest position
          scope.selectWindow = winHandler.selectWindow = function(ev){
            winHandler.onSelectWindow(ev);
            scope.$broadcast('focus', ev);
          };
          winHandler.getMaximizeToElement = function() {
            if (options.maximizeTo!=='window'){
              const elementToMaximize = document.getElementById (options.maximizeTo) || document.getElementsByTagName (options.maximizeTo);
              return (options.maximizeTo ? elementToMaximize : windowArea);
            }
            return window;
          };

          // This functions is executed when maximize is executed
          winHandler.maximize = function(callback = $.noop){
            console.log('wmwindow:maximize');
            scope.fMaximized = true;
            // Store the position and the size state
            maximizeState = {
              x: parseInt(element.prop('offsetLeft'), 10),
              y: parseInt(element.prop('offsetTop'), 10),
              width: parseInt(element.prop('offsetWidth'), 10),
              height: parseInt(element.prop('offsetHeight'), 10),
              z: element.css ('z-index'),
            };

            // Select the element where to maximize
            const maximizeToElement = winHandler.getMaximizeToElement();

            const maximizeCoords = {
              x: parseInt(maximizeToElement.offsetLeft || 0, 10) ,
              y: parseInt(maximizeToElement.offsetTop ||0, 10),
              width:  parseInt(maximizeToElement.offsetWidth || maximizeToElement.innerWidth, 10),
              height: parseInt(maximizeToElement.offsetHeight || maximizeToElement.innerHeight, 10),
            };

            // move, set the effect and resize
            // winHandler.move(maximizeCoords.x + 10,maximizeCoords.y +10 );
            element.addClass('maximizing');
            element.addClass('maximized');
            // winHandler.resize(maximizeCoords.width -20, maximizeCoords.height - 20);

            // Set the apropiate listeners
            /*
            maximizeButton.removeEventListener ('click',winHandler.maximize);
            maximizeButton.removeEventListener ('touchstart',winHandler.maximize);

            maximizeButton.addEventListener ('click',winHandler.restore);
            maximizeButton.addEventListener ('touchstart',winHandler.restore);

            titleBarElement.removeEventListener ('dblclick', winHandler.maximize);
            titleBarElement.addEventListener ('dblclick', winHandler.restore);
            */
            // Stop all the window listener (drag,resize...)
            stopWindowListeners();

            /*
            //Program the effect extraction
            setTimeout (function (){
              element.removeClass ('maximizing');

            },500);
            */
            element.on('transitionend', () => {
              element.removeClass ('maximizing');

              // element.removeClass('maximized');
              // scope.fMaximized = false;
              // scope.container.orderAndFocusLast();
              // containerwmCtrl.changeWindowManager('tab');

              callback();
            });
            // if (scope.maximize){
            //  scope.maximize(winHandler);
            // }
          };

          winHandler.restore = function(callback = $.noop){
            scope.fMaximized = false;
            // move and resize to previus state
            element.addClass('restoring');
            element.removeClass('maximized');

            // move and resize to prior state
            // winHandler.move(maximizeState.x,maximizeState.y);
            // winHandler.resize(maximizeState.width,maximizeState.height);
            element.css('z-index',maximizeState.z);
            // Restore the listeners
            /*
            maximizeButton.removeEventListener ('click',winHandler.restore);
            maximizeButton.removeEventListener ('touchstart',winHandler.restore);

            maximizeButton.addEventListener ('click',winHandler.maximize);
            maximizeButton.addEventListener ('touchstart',winHandler.maximize);

            titleBarElement.removeEventListener ('dblclick',winHandler.restore);
            titleBarElement.addEventListener ('dblclick', winHandler.maximize);
            */
            // start all the window listener (drag,resize...)
            startWindowListeners();

            // Execute restore method if it's provided
            // if (scope.restore){
            //  scope.restore(winHandler);
            // }

            /*
            //Removes the element some time ago
            setTimeout (function (){
              element.removeClass ('restoring');
            },500);
            */
            element.on('transitionend', () => {
              element.removeClass ('restoring');
              callback();
            });
          };

          function startWindowListeners(){
            /*
            titleBarElement.addEventListener ('mousedown', startMoving);
            titleBarElement.addEventListener ('touchstart', startMoving);

            //resizeButtonElement.addEventListener ('mousedown',startResizing);
            //resizeButtonElement.addEventListener ('touchstart',startResizing);
            contentButtonElement.addEventListener ('click', winHandler.selectWindow);

            //windowArea.addEventListener ('mousedown',dragWindowCorner);
            //windowArea.addEventListener ('touchstart',dragWindowCorner);
            */
          }

          function stopWindowListeners(){
            /*
            titleBarElement.removeEventListener ('mousedown', startMoving);
            titleBarElement.removeEventListener ('touchstart', startMoving);

            //resizeButtonElement.removeEventListener ('mousedown',startResizing);
            //resizeButtonElement.removeEventListener ('touchstart',startResizing);
            contentButtonElement.removeEventListener ('click', winHandler.selectWindow);

            //windowArea.removeEventListener ('mousedown',startResizing);
            //windowArea.removeEventListener ('touchstart',startResizing);
            */

          }

          // Set the window in creatio

          // Set and start all the window listener (drag,resize...)
          startWindowListeners ();

          /*
          //Set buttons listener
          closeButton.addEventListener ('click',winHandler.close);
          closeButton.addEventListener ('touchstart',winHandler.close);
          */

          /*
          maximizeButton.addEventListener ('click',winHandler.maximize);
          maximizeButton.addEventListener ('touchstart',winHandler.maximize);
          if (scope.maximizable) {titleBarElement.addEventListener ('dblclick', winHandler.maximize);}
          */

          function applyWindowOptions(wh, opt) {
            if (opt.position){
              const position = opt.position;
              wh.move(position.x, position.y);
            }
            if (opt.size){
              const size = opt.size;
              wh.resize(size.width, size.height);
            }
          }

          // apply the options for the window
          applyWindowOptions(winHandler, options);

          // To avoid adding transition listeners we remove tha clas after some time
          setTimeout(function(){
            element.addClass('active');
            element.addClass('opening');
            // winHandler.selectWindow();

            setTimeout(function(){
              element.removeClass('opening');
              if (scope.open) {
                scope.open(winHandler);
              }
            }, 400);
          }, 50);

          {
            let cb;

            window.addEventListener("resize", cb = function(e){
              if(scope.fMaximized){
                scope.$broadcast('resize', e);
              }
            }, true);
            scope.$on('$destroy', function(){
              window.removeEventListener("resize", cb, true);
            });
          }

          element[0].addEventListener('click', (event) => {
            scope.selectWindow(event);
          }, true);
          element[0].addEventListener('mousedown', (event) => {
            scope.selectWindow(event);
          }, true);
          element[0].addEventListener('touchstart', (event) => {
            scope.selectWindow(event);
          }, true);




        },
      },
    };
  }).name;
